import { getHabitsBasic } from '../util/api';

export const FETCH_HABITS_BASIC_REQUEST = 'app/habits_basic/FETCH_HABITS_BASIC_REQUEST';
export const FETCH_HABITS_BASIC_SUCCESS = 'app/habits_basic/FETCH_HABITS_BASIC_SUCCESS';
export const FETCH_HABITS_BASIC_ERROR = 'app/habits_basic/FETCH_HABITS_BASIC_ERROR';

export const initialState = {
  habits: [],
  isFetching: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_HABITS_BASIC_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_HABITS_BASIC_SUCCESS:
      return { ...state, isFetching: false, habits: payload, fetchError: null };
    case FETCH_HABITS_BASIC_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchHabitsBasicRequest = () => ({ type: FETCH_HABITS_BASIC_REQUEST });
export const fetchHabitsBasicSuccess = habits => ({
  type: FETCH_HABITS_BASIC_SUCCESS,
  payload: habits,
});
export const fetchHabitsBasicError = error => ({ type: FETCH_HABITS_BASIC_ERROR, payload: error });

// ================ Thunks ================ //

export const fetchHabitsBasicData = state => {
  return {
    habits: state.habitsBasic?.habits || [],
    isFetching: state.habitsBasic?.isFetching || false,
    fetchError: state.habitsBasic?.fetchError || null,
  };
};

export const fetchHabitsBasic = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchHabitsBasicRequest());
  try {
    const result = await getHabitsBasic(params);
    dispatch(fetchHabitsBasicSuccess(result.habits || []));
    return result;
  } catch (error) {
    console.error('Error fetching habits basic:', error);
    dispatch(fetchHabitsBasicError(error.message || 'Failed to fetch habits basic'));
    throw error;
  }
};
